<template>
    <div>
        <div class="form-mapsearch">
            <div class="group-row">
                {{ __('Írd be a város nevét / irányítószámot, ahol keresni szeretnél!') }}
            </div>

            <div class="group-row">
                <input id="search"
                       name="search"
                       v-model="search"
                       type="text"
                       class="px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline">
                <input type="submit" :value="__('Keresés')" @click="fetchStores">
                <input v-if="search" type="button" :value="__('Keresés törlése')" @click="removeSearch">
            </div>

            <div class="group-filter" v-if="filterableByType">
                <div class="group-row" v-for="storeType in storeTypes" :key="storeType.id">
                <span class="chk">
                    <input type="radio" v-model="selectedStoreType" :value="storeType.id">
                </span>
                    <label>{{ storeType.name }}</label>
                </div>
            </div>
        </div>
        <div class="row" v-if="search && stores.length === 0">
            <div class="col-md-12">
                <div class="alert alert-danger">
                    <strong>{{ __('Hiba! Nincs találat.') }}</strong>
                </div>
            </div>
        </div>
        <maps
            :stores="filteredStores"
            :lat="lat"
            :lng="lng"
        ></maps>
        <store-list
            :stores="filteredStores"
        ></store-list>
    </div>
</template>

<script>
import Maps from './Maps';
import StoreList from './StoreList';

export default {
    name: 'StoreFindex',
    components: {Maps, StoreList},
    props: {
        storesUrl: {
            type: String,
            required: true
        },
        storeTypes: {
            type: Array,
            required: true,
        },
        filterableByType: {
            type: Boolean,
            default: true,
        },
        lat: {
            type: Number,
            required: true,
        },
        lng: {
            type: Number,
            required: true,
        },
    },

    computed: {
        filteredStores() {
            if (this.selectedStoreType) {
                return _.filter(this.stores, ['storeType.id', this.selectedStoreType])
            }

            return this.stores
        }
    },

    data() {
        return {
            selectedStoreType: null,
            stores: [],
            search: null
        }
    },

    mounted() {
        this.fetchStores()

        if (this.filterableByType) {
            this.selectedStoreType = this.storeTypes[0].id
        }
    },

    methods: {
        fetchStores() {
            axios.get(this.storesUrl, { params: { search: this.search }})
                .then((response) => this.stores = response.data)
                .catch((error) => console.log(error))
        },

        removeSearch() {
            this.search = null
            this.fetchStores()
        }

    }
}
</script>

<style scoped>

</style>
